import React, { useRef, useEffect } from 'react';
import "./MapofSchools.css";

export default function Phonelessstudents({ second, listofmadestudents, originalschools, idselected, setFirst, role, setSelectedschool}) {
  let resultsRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (resultsRef.current) {
        resultsRef.current.scrollTo({
          behavior: "smooth",
          top: 1000
        });
      }
    }, 5);
  }, []);

  const selectHandler = (value) => {
    setFirst("No");
    setSelectedschool(value);
  };

  const styles = {
    unselected: {
      color: "#FFF",
      backgroundColor: "#013469",
      margin: 6,
      fontSize: 17,
      borderRadius: 10,
      textAlign: "center",
      marginLeft: 25,
      marginRight: 25,
      padding: "10px",
      cursor: "pointer"
    },
    selected: {
      color: "#fff",
      backgroundColor: "#E43522",
      margin: 6,
      fontSize: 17,
      borderRadius: 10,
      textAlign: "center",
      marginLeft: 25,
      marginRight: 25,
      padding: "10px",
      cursor: "pointer"
    },
    scrollView: {
      height: '400px',
      overflowY: 'auto'
    }
  };

  return (
    <div className="schools-scrollable-container" style={styles.scrollView} ref={resultsRef}>
      {second ? listofmadestudents.map((item) => {
        return (
          <div key={item.id}>
            <div
              style={item.id === idselected ? styles.selected : styles.unselected}
              onClick={() => selectHandler(item)}>
              {item.localfirstname} {item.locallastname}<br />Student of: {item.teacheraddingstudent}
            </div>
          </div>
        );
      }) : originalschools.map((item) => {
        return (
          <React.Fragment key={item.id}>
            {item.id == 123 && role != "Student" ? 
              <div key={item.id}>
                <div
                  style={item.id === idselected ? styles.selected : styles.unselected}
                  onClick={() => setFirst("Yes")}>
                  My School is not listed
                </div>
              </div> 
            : item.id == 123 && role == "Student" ? 
              <div key={item.id}></div> 
            : 
              <div key={item.id}>
                <div
                  style={item.id === idselected ? styles.selected : styles.unselected}
                  onClick={() => selectHandler(item)}>
                  {item.school} <br />{item.domain}<br />{item.town} <br />{item.state}
                </div>
              </div>
            }
          </React.Fragment>
        );
      })}     
    </div>
  );
}